import { ExpenseCategory } from "types/BusinessTrip";

export const EXPENSE_CATEGORY_LABEL_KEYS: Record<ExpenseCategory, string> = {
  transport: "expense_category_transport",
  fuel: "expense_category_fuel",
  accommodation: "expense_category_accommodation",
  food: "expense_category_food",
  taxes: "expense_category_taxes",
  other: "expense_category_other",
};

export const EXPENSE_CATEGORY_OPTIONS: {
  value: ExpenseCategory;
  label: string;
}[] = Object.entries(EXPENSE_CATEGORY_LABEL_KEYS).map(([value, label]) => ({
  value: value as ExpenseCategory,
  label,
}));

export const EXPENSE_CURRENCY_OPTIONS = [
  "EUR",
  "USD",
  "GBP",
  "PLN",
  "CZK",
  "SEK",
  "NOK",
  "DKK",
  "CHF",
  "BGN",
  "RON",
  "HUF",
  "TRY",
  "UAH",
  "GEL",
  "RUB",
  "CNY",
  "JPY",
].map((currency) => ({
  value: currency,
  label: currency,
}));
